import React from 'react';
import { restaurantInfo } from '../data/mockData';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Phone, MapPin, Clock } from 'lucide-react';

export const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            Contactez-Nous
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Nous sommes à votre disposition pour toute question
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <Card className="bg-[#D4A85F] backdrop-blur-sm border-none shadow-xl text-center">
            <CardHeader>
              <div className="flex justify-center mb-3">
                <div className="bg-black p-4 rounded-full">
                  <Phone className="text-white" size={28} />
                </div>
              </div>
              <CardTitle className="text-xl text-black">Téléphone</CardTitle>
            </CardHeader>
            <CardContent>
              <a
                href={restaurantInfo.phoneLink}
                className="text-lg text-gray-800 hover:text-black font-semibold transition-colors block mb-2"
              >
                {restaurantInfo.phoneDisplay}
              </a>
              {restaurantInfo.phoneSecondary && (
                <a
                  href={`tel:${restaurantInfo.phoneSecondary.replace(/\s/g, '')}`}
                  className="text-lg text-gray-800 hover:text-black font-semibold transition-colors block"
                >
                  {restaurantInfo.phoneSecondary}
                </a>
              )}
            </CardContent>
          </Card>

          <Card className="bg-[#D4A85F] backdrop-blur-sm border-none shadow-xl text-center">
            <CardHeader>
              <div className="flex justify-center mb-3">
                <div className="bg-black p-4 rounded-full">
                  <MapPin className="text-white" size={28} />
                </div>
              </div>
              <CardTitle className="text-xl text-black">Adresse</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-800">{restaurantInfo.address}</p>
            </CardContent>
          </Card>

          <Card className="bg-[#D4A85F] backdrop-blur-sm border-none shadow-xl text-center">
            <CardHeader>
              <div className="flex justify-center mb-3">
                <div className="bg-black p-4 rounded-full">
                  <Clock className="text-white" size={28} />
                </div>
              </div>
              <CardTitle className="text-xl text-black">Horaires</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-800 font-semibold">Lun-Sam</p>
              <p className="text-gray-800 text-sm">11:45-14:20, 18:00-22:20</p>
              <p className="text-gray-800 font-semibold mt-2">Dimanche</p>
              <p className="text-gray-800 text-sm">18:00-22:20</p>
            </CardContent>
          </Card>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={restaurantInfo.phoneLink}
            className="inline-flex items-center justify-center gap-2 bg-[#D4A85F] text-black px-8 py-4 rounded-md font-bold text-lg hover:bg-[#E2B978] transition-all duration-200"
          >
            <Phone size={20} />
            Appeler maintenant
          </a>
          <a
            href="https://www.google.com/maps/place/2+Avenue+de+Bourgogne,+91940+Les+Ulis"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-black text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-gray-900 transition-all duration-200"
          >
            <MapPin size={20} />
            Obtenir l'itinéraire
          </a>
        </div>
      </div>
    </section>
  );
};
